import { createInterception } from '../utils/interceptor';

document.addEventListener('DOMContentLoaded', () => {
  function activeRollingBall(element) {
    element.dataset.scroll = "in";
  }

  function enableRollingBall(element) {
    element.dataset.scroll = "out";
  }

  const elementsBall = document.querySelectorAll('.running-ball-js');

  elementsBall.forEach(element => {
    createInterception(
      element,
      () => activeRollingBall(element), // element into viewport
      { 
        unobserve: false,// false = continue observer always | true= observer only one time
        exitCallback: () => enableRollingBall(element)
      }  
    );
  });
});